// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2vy8H","footer":"ModalError_footer__23SiR"};